import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const PublicationDialog = ({
  open,
  editingLicense,
  publishingProperty,
  publishUrl,
  publishLoading,
  onOpenChange,
  onPublishUrlChange,
  onCancel,
  onSave,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingLicense ? 'Editar URL de Publicacion' : 'Publicar Propiedad'}</DialogTitle>
          <DialogDescription>
            {editingLicense ? 'Actualiza la URL del sitio publicado' : 'Ingresa la URL donde se publicara la propiedad'}
          </DialogDescription>
        </DialogHeader>
        <div className="grid w-full gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="publish-url">URL de Publicacion</Label>
            <Input
              id="publish-url"
              placeholder="https://ejemplo.netlify.app"
              value={publishUrl}
              onChange={(event) => onPublishUrlChange(event.target.value)}
              disabled={publishLoading}
            />
            <p className="text-xs text-gray-500">URL del hosting asignada al publicar el sitio</p>
          </div>

          {(() => {
            const customDomain = publishingProperty?.booking?.custom_domain || publishingProperty?.publication?.custom_domain;
            if (publishingProperty?.plan !== 'premium' || !customDomain) return null;

            const hostingHost = (() => {
              try { return new URL(publishUrl).hostname; } catch { return publishUrl.trim() || null; }
            })();
            const isApex = customDomain.replace(/^www\./, '') === customDomain;
            const recordName = isApex ? '@' : 'www';

            return (
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 space-y-3">
                <p className="text-sm font-semibold text-amber-800">
                  Plan Premium - Dominio personalizado: <span className="font-mono">{customDomain}</span>
                </p>
                <p className="text-xs text-amber-700">El cliente debe crear este registro DNS en su proveedor de dominio:</p>
                <div className="rounded bg-white border border-amber-200 p-3 text-xs font-mono space-y-1">
                  <div><span className="text-gray-500">Tipo:</span> {isApex ? 'A (o ALIAS si tu proveedor lo soporta)' : 'CNAME'}</div>
                  <div><span className="text-gray-500">Nombre:</span> {recordName}</div>
                  <div>
                    <span className="text-gray-500">Valor:</span>{' '}
                    {hostingHost
                      ? <span className="text-green-700 font-bold">{isApex ? '75.2.60.5' : hostingHost}</span>
                      : <span className="text-gray-400 italic">introduce la URL arriba para ver el valor</span>
                    }
                  </div>
                </div>
                <p className="text-xs text-amber-600">Esta informacion se enviara automaticamente al cliente por email al publicar.</p>
              </div>
            );
          })()}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={publishLoading}>Cancelar</Button>
          <Button onClick={onSave} disabled={publishLoading} className="bg-green-600 hover:bg-green-700">
            {publishLoading ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
